import { useQuery } from "@tanstack/react-query";
import api from "../../lib/api";

async function fetchMyOrders() {
  const { data } = await api.get("/order-requests/mine");
  return data;
}

export function useMyOrders(enabled) {
  return useQuery({
    queryKey: ["my-orders"],
    queryFn: fetchMyOrders,
    enabled,
  });
}
